<template>
  <div
    v-if="isvalidate"
    :class="`edt_chk_validation-message edt_chk_${normalizedMessageType}`"
  >
    <img
      :src="getImageSrc()"
      :alt="normalizedMessageType"
      class="edt_chk_validation-icon"
    />
    <span>{{ errorMsg }}</span>
  </div>
</template>

<script>
const DEFAULT_MESSAGE_TYPE = "Warning";
const MESSAGE_TYPE_IMAGE_MAP = {
  Warning: require("../../assets/img/warning2.png"),
  Information: require("../../assets/img/edt_info2.png"),
  Alert: require("../../assets/img/warning2.png"),
  Error: require("../../assets/img/alert2.png"),
  Exclusion: require("../../assets/img/Exclusion2.png"),
};

export default {
  props: {
    isvalidate: {
      type: Boolean,
      required: true,
    },
    messageType: {
      type: String,
      required: true,
    },
    errorMsg: {
      type: String,
      required: true,
    },
  },
  computed: {
    normalizedMessageType() {
      const trimmedMessageType = (this.messageType || "").trim();
      return Object.prototype.hasOwnProperty.call(
        MESSAGE_TYPE_IMAGE_MAP,
        trimmedMessageType
      )
        ? trimmedMessageType
        : DEFAULT_MESSAGE_TYPE;
    },
  },
  methods: {
    getImageSrc() {
      return MESSAGE_TYPE_IMAGE_MAP[this.normalizedMessageType];
    },
  },
};
</script>

<style scoped>
.edt_chk_validation-message {
  display: flex;
  align-items: center;
  padding: 4px;
  margin-top: 4px;
  border-radius: 6px;
  color: #68696b;
  font-size: 12px;
}
.edt_chk_validation-icon {
  width: 18px;
  height: 18px;
  margin-right: 5px;
}
.edt_chk_Warning {
  border: 1px solid #FFBB00;
  border-right: 6px solid #FFBB00;
}
.edt_chk_Information {
  border: 1px solid #62B2FD;
  border-right: 6px solid #62B2FD;
}
.edt_chk_Exclusion {
  border: 1px solid #B041B6;
  border-right: 6px solid #B041B6;
}
.edt_chk_Alert {
  border: 1px solid #FFBB00;
  border-right: 6px solid #FFBB00;
}
.edt_chk_Error {
  border: 1px solid #FD3D3A;
  border-right: 6px solid #FD3D3A;
}
</style>
